export default __webpack_public_path__ + "static/media/btc.6bcb93e6.png";